<template>
    <section class="section-wrapp">
        <RestrictionsHistoryFilterTable></RestrictionsHistoryFilterTable>
    </section>
</template>

<script>
import RestrictionsHistoryFilterTable from '@/components/stations/RestrictionsHistoryFilterTable.vue'

export default {
  name: 'RestrictionsHistoryFilter',
  components: {
    RestrictionsHistoryFilterTable
  },
  data () {
    return {
      message: ''
    }
  },
  computed: {

  },
  methods: {
    showRestrictions () {
      console.log(this.restrictions())
    }
  }
}
</script>
